<div class="dashboard-row-container">
  <!-- ==================== LEFT FIXED CARD ==================== -->
  <div class="welcome-card-container">
    <div class="text-content">
      <p class="welcome-title">Welcome Back</p>
      <p class="user-name">{{ userName }}</p>
      <p class="platform-login">Mifugo360 Platform Login</p>
    </div>

    <div class="image-content">
      <img src="assets/images/HeaderCows.png" alt="Grazing Cows" class="cow-image">
    </div>
  </div>

  <!-- ==================== RIGHT CARD ==================== -->
  <div class="onboarding-card-container">
    <div class="onboarding-inner">
      <h2>ONBOARDING PROGRESS</h2>
      <div #chartContainer class="chart-container">
        <apx-chart
          #chart
          [series]="radialChartOptions.series"
          [chart]="radialChartOptions.chart"
          [plotOptions]="radialChartOptions.plotOptions"
          [fill]="radialChartOptions.fill"
          [stroke]="radialChartOptions.stroke"
          [labels]="radialChartOptions.labels">
        </apx-chart>
      </div>
    </div>
  </div>
</div>
